import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import { useLoadTheme } from '../../../../config/loadThemeFromJson';
import { HeaderSiteRedeSocial } from '../../componentes/menuSite/HeaderSiteRedeSocial';
import ContatoCamara from './ContatoCamara';

export function EscolaLegislativoRodape() {
  const theme = useLoadTheme();
  const logo = theme.custom?.logoEscolaLegislativo || '';

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        backgroundColor: '#ADD8E6',
        overflow: 'hidden',
        minHeight: '350px',
        mt: 2
      }}
    >
      {/* box logo */}
      <Box mt={7}>
        <Box>
          <IconButton onClick={() => (window.location.href = '/escola-legislativo/home')} title="Início">
            <Box
              component="img"
              src={logo}
              alt={'logo'}
              sx={{
                objectFit: 'contain' // cobre o Box sem distorcer
              }}
            />
          </IconButton>
        </Box>

        {/* box rede social */}
        <Box mt={7} id="header-rede-social">
          <HeaderSiteRedeSocial alignment="flex-start" />
        </Box>
      </Box>

      {/* box Contato */}
      <Box mt={7}>
        <ContatoCamara />
      </Box>
    </Box>
  );
}
